const API_BASE = '';


export function RegisterPage() {
  return `
<section class="max-w-6xl mx-auto py-12 px-4">
  <h1 class="text-3xl font-bold mb-8">Register as an energy certification advisor</h1>
  <div class="grid md:grid-cols-3 gap-8">
    
    <!-- Form -->
    <form id="registerForm" class="bg-white rounded-2xl shadow p-6 md:col-span-2">

      <!-- HONEYPOT FIELD -->
      <div style="position:absolute; left:-9999px; top:-9999px;">
        <input type="text" name="hp_field" tabindex="-1" autocomplete="off">
      </div>

      <!-- TIMESTAMP FIELD -->
      <input type="hidden" name="ts" id="ts">

      <div class="mb-4">
        <label class="block text-blue-700 font-semibold mb-1">Company name</label>
        <input type="text" name="company" required
          class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-blue-700 font-semibold mb-1">First name</label>
          <input type="text" name="firstname" required
            class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
        </div>
        <div>
          <label class="block text-blue-700 font-semibold mb-1">Last name</label>
          <input type="text" name="lastname" required
            class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
        </div>
      </div>

      <div class="mb-4">
        <label class="block text-blue-700 font-semibold mb-1">Email address</label>
        <input type="email" name="email" required
          class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
      </div>

      <div class="mb-6">
        <label class="block text-blue-700 font-semibold mb-1">Phone number</label>
        <input type="tel" name="phone" required
          class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
      </div>

      <button type="submit"
        class="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 rounded-lg transition">
        Register now
      </button>
    </form>

    <!-- Benefits -->
    <aside class="bg-white rounded-2xl shadow p-6">
      <h3 class="text-lg font-semibold mb-4">All the benefits</h3>
      <ul class="space-y-2 text-blue-700 font-medium">
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">More income</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">HVAC tools</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Greater reach</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Free HVAC calculations</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Convenience</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Rating</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Market knowledge</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Real assignments</a></li>
      </ul>
    </aside>
  </div>
</section>

  `;
}


export function initializeRegisterPage() {
  const form = document.getElementById("registerForm");
  if (!form) {
    setTimeout(initializeRegisterPage, 100);
    return;
  }

  // Set timestamp as soon as form is in the DOM
  const tsField = document.getElementById("ts");
  if (tsField) {
    tsField.value = Date.now();
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    // ✅ Submit handler called

    const data = Object.fromEntries(new FormData(form));

    try {
      const response = await fetch(`${API_BASE}/api/register_advisor`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const result = await response.json();

      if (result.success) {
        alert(`Thank you for your registration, ${data.firstname}!`);
        form.reset();

        // Reset timestamp again after successful submission
        if (tsField) tsField.value = Date.now();
      } else {
        alert("Something went wrong while submitting your data. Please try again later.");
        console.error("❌ Backend error:", result.error);
      }
    } catch (err) {
      console.error("❌ Error while submitting:", err);
      alert("Something went wrong while submitting your data. Please try again later.");
    }
  });
}